<template>
  <div class="actions">
    <ui-button
      v-if="canEditQa"
      transparent
      icon="icon-edit"
      class="btn-condensed"
      @click="$emit('toggle-edit-mode')"
      >{{ $t("message.common.edit") }}</ui-button
    >
    <ui-button
      v-if="canDeleteQa"
      color="red"
      transparent
      text-color="red"
      icon="icon-trash"
      class="btn-condensed"
      @click="$emit('delete')"
      >{{ $t("message.common.delete") }}</ui-button
    >
  </div>
</template>

<script>
import { Permission } from "@/enums/permission";
import { permissionCheck } from "@/helpers/permission-check";

export default {
  name: "QaListItemOwnerActions",
  computed: {
    canDeleteQa() {
      return permissionCheck(Permission.DELETE_Q_AND_A);
    },
    canEditQa() {
      return permissionCheck(Permission.ADD_AND_EDIT_Q_AND_A);
    }
  }
};
</script>

<style lang="scss" scoped>
.actions {
  padding-left: $spacing * 2.5;
}
.btn-condensed {
  padding: $spacing * 0.1 $spacing !important;
  height: auto !important;
  border-radius: 0;
  box-sizing: content-box;

  &:before {
    content: unset;
  }

  &:hover {
    box-shadow: inset 0 -1px 0 currentColor;
  }
}
</style>
